// ============================================================
// WINNERSAURUS — Coming Soon Page
// Shown when MAINTENANCE_MODE = true in App.js
// Minimal — creates curiosity without revealing anything.
// ============================================================

import React from 'react';

export default function ComingSoon() {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--bg)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 5%',
      textAlign: 'center',
      animation: 'fadeUp 0.7s ease forwards',
    }}>

      {/* Logo */}
      <p style={{
        fontFamily: 'var(--font-display)',
        fontWeight: 800,
        fontSize: '22px',
        letterSpacing: '2px',
        color: 'var(--gold)',
        marginBottom: '64px',
        textTransform: 'uppercase',
      }}>
        Winnersaurus
      </p>

      {/* Headline */}
      <h1 style={{
        fontFamily: 'var(--font-display)',
        fontSize: 'clamp(52px, 10vw, 110px)',
        fontWeight: 800,
        lineHeight: 0.9,
        letterSpacing: '-2px',
        color: 'var(--text)',
        textTransform: 'uppercase',
        marginBottom: '32px',
      }}>
        Coming
        <br />
        <span style={{ color: 'var(--green)' }}>Soon.</span>
      </h1>

      {/* Minimal subtext */}
      <p style={{
        fontSize: 'clamp(15px, 1.8vw, 18px)',
        color: 'var(--text-muted)',
        maxWidth: '380px',
        lineHeight: 1.75,
        marginBottom: '0',
        fontFamily: 'var(--font-mono)',
        letterSpacing: '0.3px',
      }}>
        We are almost ready.
      </p>

    </div>
  );
}
